import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private httpClient = inject(HttpClient);

  ACCESS_CONTROL_PATH = '/services/access-control';

  getProducts: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/products`).toPromise();
  };

  getProductsByUser: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/products/user`).toPromise();
  };

  getProductsAdmin: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/products/admin`).toPromise();
  };

  getProductsAdminObs(){
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/products/admin`);
  };

  updateProductPromise = (product) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/products`, product).toPromise();
  };

  getUserInvoices: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/invoices`).toPromise();
  };

  retryInvoicePayment: any = (invoiceId) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/invoices/retry`, invoiceId);
  };

  getCustomerByUserSlug: any = (userSlug) => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/customer/${userSlug}`).toPromise();
  };

  // getInvoice = (invoiceId) => {
  //   return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/invoices/${invoiceId}`).toPromise();
  // }

  // getPaymentIntentByInvoice = (invoiceId) => {
  //   return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/invoices/pi/${invoiceId}`).toPromise();
  // }

  getUserSubscriptions: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/subscriptions`).toPromise();
  };

  cancelSubscription: any = (subscription) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/subscriptions/cancel`, { subscription }).toPromise();
  };

  cancelSubscriptionItem = (plan) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/subscriptions/item/cancel`, { plan }).toPromise();
  };

  renewSubscriptionItem = (plan) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/subscriptions/item/renew`, { plan }).toPromise();
  };

  renewSubscription: any = (subscription) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/subscriptions/renew`, { subscription }).toPromise();
  };

  getPaymentMethods: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/methods`).toPromise();
  };

  createSession: any = (mode, successUrl, cancelUrl, cart?) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/checkout`, { mode, successUrl, cancelUrl, cart }).toPromise();
  };

  createSessionV2: any = (mode, successUrl, cancelUrl, cart?) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/v2/payment/checkout`, { mode, successUrl, cancelUrl, cart }).toPromise();
  };

  createSetupSession: any = (url) => {
    return this.httpClient.post(`${this.ACCESS_CONTROL_PATH}/payment/setup`, { url }).toPromise();
  };

  getInvoiceStatus: any = () => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/payment/status`).toPromise();
  };

  getProductsByPermission: any = (permission) => {
    return this.httpClient.get(`${this.ACCESS_CONTROL_PATH}/products/${permission}`).toPromise();
  };
}
